


















































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import QRCode from "qrcodejs2";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
@Component({
  components: { QRCode },
})
export default class Home extends Vue {
  public qrcodeBoxOne: any = null;
  public qrcodeBoxTwo: any = null;
  public qrcodeBoxThree: any = null;
  @Prop({ type: String, default: "#FFAC1E" }) public titleColor;
  @Prop({ type: String, default: "index" }) public type;
  @Prop({ type: String, default: "" }) public qrcode;

  public onCopy(e) {
    this.$Message.success("复制成功！");
  }
  public onError(e) {
    this.$Message.error("复制失败！");
  }
  public toAdd(state, num) {
    if (state == 1) {
      window.open(
        `http://wpa.qq.com/msgrd?v=3&uin=${num}&site=qq&menu=yes`,
        "_blank"
      );
    }
    if (state == 2) {
      window.open("https://jq.qq.com/?_wv=1027&k=H9YaAx4U", "_blank");
    }
    if (state == 3) {
      window.open("https://jq.qq.com/?_wv=1027&k=TVLGaHLU", "_blank");
    }
    if (state == 4) {
      window.open("https://jq.qq.com/?_wv=1027&k=1y6PeFe5", "_blank");
    }
    if (state == 5) {
      window.open("https://jq.qq.com/?_wv=1027&k=C36umHX3", "_blank");
    }
    if (state == 6) {
      window.open("https://jq.qq.com/?_wv=1027&k=hTB8Ij3O", "_blank");
    }
    if (state == 7) {
      window.open("https://jq.qq.com/?_wv=1027&k=wXkr7wsN", "_blank");
    }
    if (state == 10) {
      window.open("https://jq.qq.com/?_wv=1027&k=nQouQVxP", "_blank");
    }
  }
  public mounted() {
    this.$nextTick(() => {
      this.qrcodes();
    });
  }
  public qrcodes() {
    // this.qrcodeBoxOne = new QRCode("qrcodesOne" + this.qrcode, {
    //   width: 100,
    //   height: 100, // 高度
    //   text: "http://wpa.qq.com/msgrd?v=3&uin=5285770&site=qq&menu=yes", // 二维码内容
    //   render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // });
    this.qrcodeBoxTwo = new QRCode("qrcodesTwo", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=nQouQVxP", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    this.qrcodeBoxThree = new QRCode("qrcodesThree", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=TVLGaHLU", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    this.qrcodeBoxThree = new QRCode("qrcodesFive", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=1y6PeFe5", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    // this.qrcodeBoxThree = new QRCode("qrcodesSix", {
    //   width: 100,
    //   height: 100, // 高度
    //   text: "https://jq.qq.com/?_wv=1027&k=C36umHX3", // 二维码内容
    //   render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // });
    this.qrcodeBoxThree = new QRCode("qrcodesSeven", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=hTB8Ij3O", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    this.qrcodeBoxThree = new QRCode("qrcodesEight", {
      width: 100,
      height: 100, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=wXkr7wsN", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
  }
}
